import { Link } from 'react-router-dom'
import type { UebersichtEintrag as Eintrag } from '../../hooks/uebersichtRegeln'
import { zeitKurz } from '../news/newsZeit'
import s from './UebersichtEintrag.module.scss'

/**
 * Ein Eintrag in Positiv oder Negativ.
 *
 * Der Punkt vorn ist nur bei Neuem gefüllt. Die Kopfzeile sagt Typ,
 * Kennzahl in der Farbe des Vorzeichens und Zeit; darunter Titel, Detail und
 * das Ziel. Die ganze Zeile führt dorthin, wo der Eintrag herkommt.
 */
export function UebersichtEintrag({ eintrag }: { eintrag: Eintrag }) {
  return (
    <Link to={eintrag.to} className={s.eintrag}>
      <span className={s.punkt} data-neu={eintrag.neu || undefined} aria-hidden="true" />
      <span className={s.inhalt}>
        <span className={s.kopf}>
          <span className={s.typ}>{eintrag.typ}</span>
          <span className={s.kennzahl} data-vorzeichen={eintrag.vorzeichen}>{eintrag.kennzahl}</span>
          <span className={s.zeit}>{eintrag.zeitText ?? zeitKurz(eintrag.zeit)}</span>
        </span>
        <span className={s.titel}>{eintrag.titel}</span>
        {eintrag.detail && <span className={s.detail}>{eintrag.detail}</span>}
        <span className={s.ziel}>{eintrag.ziel}</span>
      </span>
    </Link>
  )
}
